const i = o => o && "olx-d-".concat(o);
export { i as withDisplay };